export default {
  pages: state => state.list,
  pageBySlug: state => slug => state.list.find(page => page.slug === slug)
};
